import {
    BOOKING_DETAIL_SUCCESS,
    BOOKING_DETAIL_ERROR,
    BOOKING_DETAIL_START,
    UPDATE_BOOKING_DETAIL_SUCCESS,
    UPDATE_BOOKING_DETAIL_ERROR
  } from "Constant";
  
  const initialState = {
    loading: false,
    data: [],
      // data:null
      
  };
  
  export default function BookingDetailReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case BOOKING_DETAIL_START:
        return {
          ...state,
          loading: true,
        };
      case BOOKING_DETAIL_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case BOOKING_DETAIL_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
        case UPDATE_BOOKING_DETAIL_SUCCESS:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
        case UPDATE_BOOKING_DETAIL_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }
  